import { useCallback } from 'react';
import { useOneButtonStore } from '../store/oneButtonStore';
import { getOneButtonCapabilityValue, hasOneButtonCapability } from '../services/oneButtonServices/capabilityService';

export const useOneButtonCapability = () => {
    const onebuttonCapabilities = useOneButtonStore((s) => s.onebuttonCapabilities);

    const getCapabilityValue = useCallback(
        (name: string) => getOneButtonCapabilityValue(onebuttonCapabilities, name),
        [onebuttonCapabilities]
    );

    const hasCapability = useCallback(
        (name: string) => hasOneButtonCapability(onebuttonCapabilities, name),
        [onebuttonCapabilities]
    );

    return { getCapabilityValue, hasCapability };
};

